<template>
  <div v-rect-loading="loading" v-if="ready" class="mobile-resume-page" :style="customStyle">
  <ResumeEditor
    :resumeInfo="resumeInfo"
    :resumeEditorSetting="resumeEditorSetting"
    :hiddenSteps="hiddenSteps"
    :needUploadResume="needUploadResume"
    :showUploadButton="showUploadButton"
    :hasOpenQuestion="hasOpenQuestion"
    :isEditMode="isEditMode"
    :isAddMode="isAddMode"
    :isMiniResume="isMiniResume"
    :personalInfo="personalInfo"
    :customPageInfo="customPageInfo"
    :hiddenBackBtn="hiddenBackBtn"
    :isFromPreference="isFromPreference"
    :handlerSaveOpenQuestion="handlerSaveOpenQuestion"
    :handlerSaveInviteQuestion="handlerSaveInviteQuestion"
    @saveResume="handlerSaveResume"
    @finishResumeOrApplyJob="handlerFinishResumeOrApplyJob"
    @formatResumeData="formatResumeData"
    @changeResumeSetting="handleChangeResumeSetting"
    @skip="goSkip"
    @back="goBack"
  />
  </div>
</template>

<script>
import _ from 'lodash'
import ResumeEditor from '@/components/candidate/mobile/layout.vue'
import { mapActions } from 'vuex'
import { STEP_TYPE } from '@/constant/candidate'
import { mixedRouterPush } from '@/router/routes'

const ELC_COMPANY = 6172

export default {
  components: {
    ResumeEditor
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      ready: false,
      resumeInfo: {},
      needUploadResume: false,
      readyPromise: [],
      ...STEP_TYPE,
      miniResumeHiddenStep: [STEP_TYPE.WORK_EXPERIENCE, STEP_TYPE.EDUCATION, STEP_TYPE.ADDITIONAL_INFO],
      loading: false,
      personalInfo: {},
      hiddenSteps: [STEP_TYPE.SUBMIT_REFERRAL, STEP_TYPE.JOB_QUESTIONNAIRE, STEP_TYPE.INVITE_QUESTIONNAIRE],
      skipParseResume: false,
      resumeEditorSetting: {
        isMiniResume: false,
        isBasicResume: false,
        isCandidate: true,
        hiddenField: [],
        requiredField: [],
        profileStep: 0,
        [STEP_TYPE.UPLOAD_RESUME]: {
          showThirdParty: true,
          onlyUploadResume: false,
          showCreateNewBtn: false,
          showFooter: false,
          importResumeTip: null
        },
        [STEP_TYPE.BASE_INFO]: {
          canEditEmail: false,
          workCount: 0,
          displayField: [],
          disabledField: ['mobile', 'emailAddress'],
          requiredField: ['emailAddress', 'mobile', 'gender', 'birthday', 'personalStatement', 'homeLocation', 'currentLocation', 'country', 'province', 'city', 'currentCountry', 'currentProvince', 'currentCity']
        },
        [STEP_TYPE.WORK_EXPERIENCE]: {
          interCount: 0,
          workCount: 0
        },
        [STEP_TYPE.EDUCATION]: {
          eduRequiredCount: 1,
          languageRequiredField: ['language', 'level', 'certification', 'score']
        },
        // [STEP_TYPE.ADDITIONAL_INFO]: {

        // },
        [STEP_TYPE.RESUME_INFO]: {

        },
        [STEP_TYPE.JOB_QUESTIONNAIRE]: {
          isElcCompany: false
        }
      },
      showUploadButton: true,
      hasOpenQuestion: false,
      currentStep: null,
      canReapply: false,
      finishedApply: false,
      customStyle: null,
      customPageInfo: {}
    }
  },
  computed: {
    isEditMode () {
      if (!this.isMiniResume && this.personalInfo?.profile_step !== 2) {
        return false
      }
      return this.$route.meta.isEditMode && !this.jobId
    },
    isAddMode () {
      return this.$route.meta.isAddMode && !this.jobId
    },
    isMiniResume () {
      return this.$route.meta.isMiniResume
    },
    isBasicResume () {
      return this.$route.meta.isBasicResume
    },
    onlyUploadResume () {
      return this.$route.query.only_upload_resume === '1'
    },
    parseResume () {
      return this.$route.query.parse_resume === '1'
    },
    onlyOpenQuestion () {
      return this.$route.query.only_open_question === '1'
    },
    onlyInviteQuestion () {
      return this.$route.query.only_invite_question === '1'
    },
    onlyEditResume () {
      return this.$route.query.only_edit_resume === '1'
    },
    applyUrl () {
      return this.$route.query.apply_url
    },
    jobId () {
      // TODO not use,  jobId in the path query is a bad param
      return this.$route.query.job_id || this.$route.query.jobId
    },
    companyId () {
      return this.$route.query.company_id
    },
    inviteUploadResumeHistoryId () {
      return this.$route.query.history_id
    },
    isFromPreference () {
      return this.$route.query.is_from_preference === '1'
    },
    hiddenBackBtn () {
      const isManualEdit = this.$route.query.is_manual_edit === '1'
      return this.onlyUploadResume && this.isFromPreference && !isManualEdit
    }
  },
  created () {
    this.readyPromise.push(this.getResumeInfo())
    this.readyPromise.push(this.loadPersonalInfo())
    this.readyPromise.push(this.loadJobApplyStatus())
    this.readyPromise.push(this.loadCompanyInfo())
    this.readyPromise.push(this.loadCustomJobListPageInfo())
    this.changeLoading(true)
    Promise.all(this.readyPromise).then(() => {
      this.initResumeSetting()
      this.ready = true
    }).finally(() => {
      this.changeLoading(false)
    })
  },
  mounted () {
    if (this.onlyUploadResume) {
      this.resumeEditorSetting[STEP_TYPE.UPLOAD_RESUME].onlyUploadResume = true
      this.resumeEditorSetting.skipParseResume = !this.parseResume
      if (this.hiddenSteps.includes(STEP_TYPE.UPLOAD_RESUME)) {
        this.hiddenSteps.splice(this.hiddenSteps.indexOf(STEP_TYPE.UPLOAD_RESUME), 1)
      }
      const hiddenSteps = [STEP_TYPE.BASE_INFO, STEP_TYPE.EDUCATION, STEP_TYPE.WORK_EXPERIENCE, STEP_TYPE.ADDITIONAL_INFO, STEP_TYPE.RESUME_INFO, STEP_TYPE.SUBMIT_REFERRAL]
      this.hiddenSteps = _.concat(this.hiddenSteps, hiddenSteps)
    }
    if (this.onlyOpenQuestion) {
      // 只回答openQuestion，不显示其他页面
      const hiddenSteps = [STEP_TYPE.UPLOAD_RESUME, STEP_TYPE.BASE_INFO, STEP_TYPE.EDUCATION, STEP_TYPE.WORK_EXPERIENCE, STEP_TYPE.LANGUAGE, STEP_TYPE.ADDITIONAL_INFO, STEP_TYPE.RESUME_INFO, STEP_TYPE.SUBMIT_REFERRAL]
      this.hiddenSteps = _.concat(this.hiddenSteps, hiddenSteps)
    }
    if (this.onlyInviteQuestion) {
      // 只回答inviteQuestion，不显示其他页面
      const hiddenSteps = [STEP_TYPE.UPLOAD_RESUME, STEP_TYPE.BASE_INFO, STEP_TYPE.EDUCATION, STEP_TYPE.WORK_EXPERIENCE, STEP_TYPE.LANGUAGE, STEP_TYPE.ADDITIONAL_INFO, STEP_TYPE.RESUME_INFO, STEP_TYPE.SUBMIT_REFERRAL]
      this.hiddenSteps = _.concat(this.hiddenSteps, hiddenSteps)
    }
    if (this.isFromPreference) {
      this.resumeEditorSetting[STEP_TYPE.UPLOAD_RESUME].showCreateNewBtn = true
      this.resumeEditorSetting[STEP_TYPE.UPLOAD_RESUME].showFooter = this.onlyUploadResume
      this.resumeEditorSetting[STEP_TYPE.UPLOAD_RESUME].importResumeTip = this.$t(`${this.i18nPrefix}.label.preferenceTip`)
    }
  },
  methods: {
    ...mapActions('personal', [
      'getPersonalInfo',
      'getResumeData',
      'createOrUpdateResumeData',
      'uploadCandidatePhoto',
      'getMiniResumeData',
      'createOrUpdateMiniResumeData',
      'getBasicResumeData',
      'createOrUpdateBasicResumeData',
      'personalUploadResume',
      'updatePersonalCandidateAvatar',
      'saveJobQuestion',
      'getJobInviteQuestion',
      'getJobQuestion',
      'saveJobInviteQuestion',
      'dispatchApply'
    ]),
    ...mapActions('company', ['getCompanyBaseInfo', 'getCustomJobListPageInfo']),
    ...mapActions('job', ['getJobApplyStatus']),
    ...mapActions('application', ['getJobApplyRequiredInfo']),
    async getResumeInfo () {
      let getResumeMethod = this.getResumeData
      if (this.isMiniResume) {
        getResumeMethod = this.getMiniResumeData
      } else if (this.isBasicResume) {
        getResumeMethod = this.getBasicResumeData
      }

      const resp = await getResumeMethod({ job_id: this.jobId, company_id: this.companyId })
      if (resp) {
        if (this.isBasicResume) {
          this.resumeInfo = resp
        } else {
          this.formatResumeData(resp)
        }
      }
      if (this.jobId) {
        const jobApplyRequiredInfoResp = await this.getJobApplyRequiredInfo(this.jobId)
        if (jobApplyRequiredInfoResp) {
          this.dealJobApplyRequiredInfo(jobApplyRequiredInfoResp)
        }
        if (!this.onlyEditResume && !this.onlyUploadResume) {
          await this.getJobOpenQuestion()
        }
      }
    },
    async loadPersonalInfo () {
      const resp = await this.getPersonalInfo({ company_id: this.companyId })
      if (resp) {
        if (resp.need_create_password) {
          return this.$router.push({ path: `/passport/candidate/create-password/${resp.password_reset_code}/`, query: { back: this.$route.fullPath } })
        }
        this.personalInfo = resp
        this.resumeEditorSetting.profileStep = this.personalInfo.profile_step
      }
    },
    initResumeSetting () {
      const baseInfoSetting = this.resumeEditorSetting[STEP_TYPE.BASE_INFO]
      if (this.isMiniResume || this.isBasicResume) {
        this.resumeEditorSetting.isMiniResume = true
        this.hiddenSteps.push(...this.miniResumeHiddenStep)
        baseInfoSetting.requiredField.push('address')
        if (this.isBasicResume) {
          this.hiddenSteps.push(STEP_TYPE.RESUME_INFO)
          this.resumeEditorSetting.isMiniResume = false
          this.resumeEditorSetting.isBasicResume = true
          this.showUploadButton = false
        }
      }
      if (!_.isEmpty(this.resumeInfo.educationInfo)) {
        _.forEach(this.resumeInfo.educationInfo[0], (item, key) => {
          this.$set(this.resumeInfo.baseInfo, key, item)
        })
      }
      if (!this.jobId && this.resumeEditorSetting[STEP_TYPE.WORK_EXPERIENCE].workCount <= 1) {
        this.resumeEditorSetting[STEP_TYPE.BASE_INFO].workCount = 1
        this.resumeEditorSetting[STEP_TYPE.WORK_EXPERIENCE].workCount = 1
      }
    },
    dealJobApplyRequiredInfo (info) {
      if (!info) {
        return
      }
      if (this.onlyOpenQuestion || this.onlyInviteQuestion) {
        this.showUploadButton = false
        this.hiddenSteps.push(STEP_TYPE.UPLOAD_RESUME)
        return
      }
      // 重复申请 或者 求职者申请成功后重新返回申请页面，也需要上传简历
      if (this.resumeInfo.is_application_resume && !this.canReapply && !this.finishedApply) {
        if (this.resumeInfo.baseInfo.has_upload_resume && !this.onlyUploadResume) {
          this.showUploadButton = false
          this.hiddenSteps.push(STEP_TYPE.UPLOAD_RESUME)
          return
        } else {
          this.skipParseResume = true
        }
      }
      const requiredField = info.required_field || []
      if (requiredField.includes('resume')) {
        this.needUploadResume = true
        if (this.hiddenSteps.includes(STEP_TYPE.UPLOAD_RESUME)) {
          this.hiddenSteps.splice(this.hiddenSteps.indexOf(STEP_TYPE.UPLOAD_RESUME), 1)
        }
        this.showUploadButton = false
      }
      if (!_.isEmpty(info.hidden_field)) {
        this.resumeEditorSetting[STEP_TYPE.BASE_INFO].hiddenField.push(...info.hidden_field)
      }
      if (info.work_experience_count) {
        this.resumeEditorSetting[STEP_TYPE.WORK_EXPERIENCE].workCount = 1
        this.resumeEditorSetting[STEP_TYPE.BASE_INFO].workCount = 1
      }
    },
    async getJobOpenQuestion () {
      const openQuestion = {
        standard: [],
        invite: []
      }
      if (!this.onlyInviteQuestion) {
        const resp = await this.getJobQuestion({ jobId: this.jobId })
        if (resp?.questions && !_.isEmpty(resp.questions)) {
          this.hasOpenQuestion = true
          this.hiddenSteps.splice(this.hiddenSteps.indexOf(STEP_TYPE.JOB_QUESTIONNAIRE), 1)
          openQuestion.standard = resp.questions
        }
      }
      const resp = await this.getJobInviteQuestion({ jobId: this.jobId })
      if (resp?.questions && !_.isEmpty(resp.questions)) {
        this.hasOpenQuestion = true
        this.hiddenSteps.splice(this.hiddenSteps.indexOf(STEP_TYPE.INVITE_QUESTIONNAIRE), 1)
        openQuestion.invite = resp.questions
      }
      this.$set(this.resumeInfo, 'openQuestion', openQuestion)
    },
    async handlerSaveOpenQuestion (answer, isLastStep) {
      if (!_.isEmpty(answer)) {
        const data = {
          is_last: 1,
          answer: answer
        }
        this.changeLoading(true)
        try {
          await this.saveJobQuestion({ jobId: this.jobId, data: data })
        } finally {
          this.changeLoading(false)
        }
      }
    },
    async handlerSaveInviteQuestion (answer, isLastStep) {
      if (!_.isEmpty(answer)) {
        const data = {
          is_last: 1,
          answer: answer
        }
        this.changeLoading(true)
        try {
          await this.saveJobInviteQuestion({ jobId: this.jobId, data: data })
        } finally {
          this.changeLoading(false)
        }
      }
    },
    async handlerSaveResume (resumeData, isFinishEditResume, callback) {
      let saveMethod = this.createOrUpdateResumeData
      if (this.isMiniResume) {
        saveMethod = this.createOrUpdateMiniResumeData
      } else if (this.isBasicResume) {
        saveMethod = this.createOrUpdateBasicResumeData
      }
      let photoPath
      try {
        this.changeLoading(true)
        await saveMethod({ jobId: this.jobId, companyId: this.companyId, resumeData })
        const photo = resumeData.baseInfo?.photoFile
        if (photo) {
          const resp = await this.uploadCandidatePhoto({ photo: photo, jobId: this.jobId, companyId: this.companyId })
          if (resp) {
            photoPath = resp.photo_path
          }
        }
        if (isFinishEditResume && this.jobId && this.hasOpenQuestion) {
          await this.applyJobFirstStep()
        }
      } finally {
        this.changeLoading(false)
      }
      if (this.onlyUploadResume) {
        this.$message({
          type: 'success',
          message: this.$t(`${this.i18nPrefix}.message.uploadSuccess`)
        })
        const back = this.$route.query.back || `/recruiting/personal/home${this.companyId ? `?company_id=${this.companyId}` : ''}`
        setTimeout(() => {
          mixedRouterPush(back)
        }, 500)
        return
      }
      if (callback) {
        callback(photoPath)
      }
    },
    // async goBack (isLastStep) {
    //   if (this.onlyUploadResume) {
    //     this.$message({
    //       type: 'success',
    //       message: this.$t(`${this.i18nPrefix}.message.uploadSuccess`)
    //     })
    //     setTimeout(() => {
    //       mixedRouterPush(`/recruiting/personal/home${this.companyId ? `?company_id=${this.companyId}` : ''}`)
    //     }, 500)
    //     return
    //   }
    //   if (isLastStep) {
    //     const applyUrl = this.applyUrl || ''
    //     const jobId = this.jobId
    //     if (this.hasOpenQuestion) {
    //       return mixedRouterPush(`${applyUrl}${(applyUrl.includes('?') ? '&after_open_question=1' : '?after_open_question=1')}${this.needUploadResume ? '&uploaded_resume=1' : ''}`)
    //     } else {
    //       if (applyUrl) {
    //         mixedRouterPush(this.needUploadResume ? `${applyUrl}${(applyUrl.includes('?') ? '&uploaded_resume=1' : '?uploaded_resume=1')}` : applyUrl)
    //       } else if (jobId) {
    //         this.changeLoading(true)
    //         try {
    //           const resp = await this.updatePersonalCandidateAvatar()
    //           if (resp) {
    //             mixedRouterPush(`/apply-job-process/${jobId}/`)
    //           }
    //         } finally {
    //           this.changeLoading(false)
    //         }
    //       } else {
    //         mixedRouterPush(`/mobile-web-mini-resume/${this.companyId ? `?company_id=${this.companyId}` : ''}`)
    //       }
    //     }
    //   }
    // },
    async applyJobFirstStep () {
      // 如果有open question 完成申请流程一步（创建申请记录等逻辑）
      const params = {
        after_resume: 1,
        need_response_json: 1
      }
      if (this.needUploadResume) {
        params.uploaded_resume = 1
      }
      await this.dispatchApply({ jobId: this.jobId, params: params })
    },
    async handlerFinishResumeOrApplyJob () {
      if (this.isFromPreference) {
        const back = this.$route.query.back
        if (back) {
          mixedRouterPush(back)
        }
        return
      }
      this.changeLoading(true)
      const applyUrl = this.applyUrl || ''
      const jobId = this.jobId
      if (this.hasOpenQuestion) {
        return mixedRouterPush(`${applyUrl}${(applyUrl.includes('?') ? '&after_open_question=1' : '?after_open_question=1')}${this.needUploadResume ? '&uploaded_resume=1' : ''}`)
      } else {
        if (applyUrl) {
          mixedRouterPush(this.needUploadResume ? `${applyUrl}${(applyUrl.includes('?') ? '&uploaded_resume=1' : '?uploaded_resume=1')}` : applyUrl)
        } else if (jobId) {
          this.changeLoading(true)
          try {
            const resp = await this.updatePersonalCandidateAvatar({ jobId: jobId, data: { companyId: this.companyId } })
            if (resp) {
              mixedRouterPush(`/apply-job-process/${jobId}/`)
            }
          } finally {
            this.changeLoading(false)
          }
        } else {
          mixedRouterPush(`/mobile-web-mini-resume/${this.companyId ? `?company_id=${this.companyId}` : ''}`)
        }
      }
    },
    async loadJobApplyStatus () {
      if (this.jobId) {
        const resp = await this.getJobApplyStatus({ job_id: this.jobId })
        if (resp) {
          this.canReapply = resp.can_reapply
          this.finishedApply = resp.finish_apply === 1
        }
      }
    },
    async loadCompanyInfo () {
      if (this.companyId) {
        const resp = await this.getCompanyBaseInfo({ id: this.companyId })
        if (resp) {
          if (resp.custom_color) {
            this.customStyle = {
              '--custom-color': resp.custom_color
            }
          }
          this.resumeEditorSetting[STEP_TYPE.JOB_QUESTIONNAIRE].isElcCompany = resp.company.root_company.id === ELC_COMPANY
        }
      }
    },
    async loadCustomJobListPageInfo () {
      if (this.companyId) {
        const resp = await this.getCustomJobListPageInfo({ company_id: this.companyId })
        if (resp) {
          this.customPageInfo = resp
        }
      }
    },
    formatResumeData (resumeData, callback) {
      if (resumeData.isUpload && this.skipParseResume) {
        this.resumeInfo.resumePath = resumeData.resumePath
        this.resumeInfo.isUpload = resumeData.isUpload
        return
      }
      resumeData.resumePath = resumeData.baseInfo.resume_path
      const baseInfo = resumeData.baseInfo
      baseInfo.currentCity = baseInfo.currentCityId
      baseInfo.currentCountry = baseInfo.currentCountryId
      baseInfo.currentProvince = baseInfo.currentProvinceId
      baseInfo.city = baseInfo.cityId
      baseInfo.country = baseInfo.countryId
      baseInfo.province = baseInfo.provinceId

      if (this.resumeInfo?.baseInfo?.photo) {
        baseInfo.photo = this.resumeInfo?.baseInfo?.photo
      }
      if (this.resumeInfo?.baseInfo?.emailAddress) {
        baseInfo.emailAddress = this.resumeInfo?.baseInfo?.emailAddress
      }
      if (this.resumeInfo?.baseInfo?.mobile) {
        baseInfo.mobile = this.resumeInfo?.baseInfo?.mobile
      }

      const educationInfo = resumeData.educationInfo
      if (educationInfo) {
        _.forEach(educationInfo, item => {
          item.school = item.schoolName
        })
      }

      const workExperienceInfo = resumeData.workExperienceInfo
      const partTimeExperience = workExperienceInfo.partTimeExperience
      if (partTimeExperience) {
        _.forEach(partTimeExperience, item => {
          item.industry = item.industryId
          item.salary = item.salaryId
        })
      }
      const workExperience = workExperienceInfo.workExperience
      if (workExperience) {
        _.forEach(workExperience, item => {
          item.industry = item.industryId
          item.salary = item.salaryId
        })
      }
      resumeData.openQuestion = this.resumeInfo.openQuestion
      this.resumeInfo = resumeData
      if (callback) {
        callback()
      }
    },
    changeLoading (value) {
      if (value) {
        this.$eventBus.$emit('showLoading', true)
        document.body.style.overflow = 'hidden'
      } else {
        this.$eventBus.$emit('showLoading', false)
        document.body.style.overflow = ''
      }
    },
    handleChangeResumeSetting () {
      this.$router.replace({
        query: {
          ...this.$route.query,
          only_upload_resume: 0,
          step: STEP_TYPE.BASE_INFO
        }
      })
      const showStep = [
        STEP_TYPE.UPLOAD_RESUME,
        STEP_TYPE.BASE_INFO,
        STEP_TYPE.EDUCATION,
        STEP_TYPE.WORK_EXPERIENCE,
        STEP_TYPE.LANGUAGE,
        STEP_TYPE.RESUME_INFO
      ]
      this.hiddenSteps = _.filter(this.hiddenSteps, step => !_.includes(showStep, step))
      this.resumeEditorSetting[STEP_TYPE.UPLOAD_RESUME].onlyUploadResume = false
      this.resumeEditorSetting.skipParseResume = false
    },
    goSkip () {
      if (this.isFromPreference) {
        const backUrl = this.$route.query.back
        mixedRouterPush(backUrl)
      }
    },
    goBack () {
      if (this.isFromPreference) {
        this.$router.back()
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.currentStep = this.$route.query.step
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-resume-page {
  .confirm-update-self-resume {
    ::v-deep {
      .dialog-content {
        border-top-color: var(--custom-color);
        .body-content {
          min-height: 10vh;
          min-height: 10dvh;
        }
        .container-footer {
          .dialog-footer {
            .save-btn {
              background: #fff;
              color: var(--custom-color, #0096cc);
              border: 1px solid var(--custom-color, #0096cc);
            }
          }
        }
      }
    }
  }
}
</style>
